/**
 * @generated SignedSource<<27b2df114587431263d5d850642d7f7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceEdit_space$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "OrgSpaceEdit_space";
};
export type OrgSpaceEdit_space$key = {
  readonly " $data"?: OrgSpaceEdit_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceEdit_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSpaceEdit_space",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "StorecastSpace",
  "abstractKey": null
};

(node as any).hash = "2527f7f573ebfd87c90cb485fc57fd99";

export default node;
